import type { ReactNode } from 'react';
import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { logout } from '../api/auth';

const navItems = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/contacts', label: 'Contacts' },
  { to: '/leads', label: 'Leads' },
  { to: '/deals', label: 'Deals' },
  { to: '/tasks', label: 'Tasks' },
  { to: '/automations', label: 'Automations' },
  { to: '/integrations', label: 'Integrations' },
  { to: '/analytics', label: 'Analytics' },
];

export function Layout({ children }: { children: ReactNode }) {
  const { user, setUser } = useAuth();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  async function onSignOut() {
    try {
      await logout();
    } finally {
      setUser(null);
      window.location.href = 'https://crmify.io';
    }
  }

  return (
    <>
      <nav className="skip-links" aria-label="Skip links">
        <a href="#main-content">Skip to main content</a>
        <a href="#sidebar-nav">Skip to navigation</a>
      </nav>
      <div className="app-shell">
        <aside className={isMobileNavOpen ? 'sidebar sidebar--open' : 'sidebar'}>
          <div className="sidebar__top">
            <a className="sidebar__brand logo-link" href="https://crmify.io">
              <span className="logo">🚀</span>
              <span>CRMify.io</span>
            </a>
            <button
              className="sidebar__toggle"
              type="button"
              aria-expanded={isMobileNavOpen}
              aria-controls="sidebar-nav"
              onClick={() => setIsMobileNavOpen((open) => !open)}
            >
              {isMobileNavOpen ? 'Close' : 'Menu'}
            </button>
          </div>
          <nav className="sidebar__nav" id="sidebar-nav">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => (isActive ? 'nav-item nav-item--active' : 'nav-item')}
                onClick={() => setIsMobileNavOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="sidebar__footer">
            <div className="sidebar__user">
              <strong>{user?.fullName ?? user?.email}</strong>
              <span>{user?.role}</span>
            </div>
            <Link className="btn btn--ghost" to="/profile" onClick={() => setIsMobileNavOpen(false)}>
              Manage profile
            </Link>
            <button className="btn btn--ghost" onClick={onSignOut}>
              Sign out
            </button>
          </div>
        </aside>
        <main className="main-content" id="main-content" role="main" aria-label="Main content">
          {children}
        </main>
      </div>
    </>
  );
}
